import { useCallback } from 'react'
import { useReduxAuth } from '../../app/modules/auth/useReduxAuth'

/**
 * Custom logout hook that provides efficient logout functionality
 * Prevents intermediate redirects and loading states during logout process
 */
export const useLogout = () => {
  const { logout } = useReduxAuth()

  const performLogout = useCallback(async () => {
    try {
      // Step 1: Immediately clear local state and storage to prevent routing confusion
      localStorage.clear()
      sessionStorage.clear()

      // Step 2: Call logout to handle API cleanup (runs in background)
      logout()

      // Step 3: Immediately redirect to login without waiting for Redux state updates
      // This prevents the app from trying to route to dashboard during logout
      window.location.replace('/login')
    } catch (error) {
      console.error('Logout error:', error)
      // Even if something fails, force redirect to login
      window.location.replace('/login')
    }
  }, [logout])

  return { performLogout }
}

export default useLogout